import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { CollectionService } from '@services/collection.service';
import { NotificationService } from '@services/notification.service';
import { Subscription } from 'rxjs';
import { EditCollectionComponent } from '../edit-collection/edit-collection.component';
import { RoleManagementService } from '@services/role.management.service';
import { AccountAdminRole } from '@configs/role.config';
import { WebErrorService } from '@services/webError.service';
import { videoAssetGroups } from '@configs/videoTitles';
@Component({
  selector: 'app-collection-details',
  templateUrl: './collection-details.component.html',
  styleUrls: ['./collection-details.component.scss']
})

export class CollectionDetailsComponent implements OnInit, OnChanges, OnDestroy {
  // variable declaration
  timeZone: any;
  language: string;
  languagesData$: Subscription | undefined;
  timeZoneData$: Subscription | undefined;
  collectionPostData$: Subscription | undefined;
  languageArr = [];
  timeZoneArr = [];
  globalcollectionuuId: any;
  userForm: FormGroup;
  collection: any;
  selectedLanguage: any;
  selectedTimeZone: any;
  collectionUpdateData: any;
  collectionNameDisplay: any;
  collectionDescriptionDisplay: any;
  tab: any;
  tab1: boolean = false;
  accountAdmin = AccountAdminRole.accountAdmin;
  selectedTabIndex = 0;
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(
    private collectionService: CollectionService,
    private notificationService: NotificationService,
    private router: Router,
    public dialog: MatDialog,
    public roleSer: RoleManagementService,
    private webErrorService: WebErrorService
  ) {
    const readUrl = this.router.url;
    const url1 = readUrl.split('/');
    this.globalcollectionuuId = url1[2];
  }

  ngOnInit(): void {
    this.collectionService.getNewCollectionData.subscribe(resData => {
      this.collectionService.getCollectionDetails(this.globalcollectionuuId).subscribe((result) => {
        this.collection = result?.data;
        this.collectionNameDisplay = this.collection?.collectionName;
        this.collectionDescriptionDisplay = this.collection?.description;
      });
    });

    this.languagesData$ = this.collectionService
      .getLanguages()
      ?.subscribe((languagesData: any) => {
        this.languageArr = languagesData?.items;
        this.selectedLanguage = 'English';
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });

    this.timeZoneData$ = this.collectionService
      .getTimeZone()
      ?.subscribe((timeZoneData: any) => {
        this.timeZoneArr = timeZoneData?.items;
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });

    this.userForm = new FormGroup({
      collectionName: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(120),
      ]),
      description: new FormControl(null),
      langid: new FormControl(null, [Validators.required]),
      timezoneid: new FormControl(null, [Validators.required]),
    });

    this.collectionService
      .getCollectionDetails(this.globalcollectionuuId)
      .subscribe((result) => {
        this.collection = result?.data;
        this.collectionNameDisplay = this.collection?.collectionName;
        this.collectionDescriptionDisplay = this.collection?.description;
        this.userForm
          .get('collectionName')
          .setValue(this.collection?.collectionName);
        this.userForm.get('description').setValue(this.collection?.description);
        const selectedLanguage = this.userForm
          .get('langid')
          .setValue(this.collection?.langid);
        const timeZone = this.userForm
          .get('timezoneid')
          .setValue(this.collection?.timezoneid);
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  onTraningIcon(assetGroup) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.collectionService.videoTutorial(assetGroup).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  get f(): any {
    return this.userForm.controls;
  }

  ngOnChanges(): void { }
  saveBtnFn(): void {
    if (this.userForm.value.description != null) {
      this.userForm.value.description = this.userForm.value.description.trim();
    } else {
      this.userForm.value.description = this.userForm.value.description;
    }
    const apiData = {
      collectionName: this.userForm.value.collectionName.trim(),
      description: this.userForm.value.description,
      langid: this.userForm.value.langid,
      timezoneid: this.userForm.value.timezoneid,
      timezoneName: "",
    };

    this.collectionService
      .UpdateCollectionDetails(this.globalcollectionuuId, apiData)
      ?.subscribe(
        (data) => {
          this.notificationService.success(data?.message);
          this.router.navigate(['collections']);
        }, (error: any) => {
          this.webErrorService.handleAPIErrors(error, '', true, 'warn');
        });
  }
  navigatetoCollection(): void {
    this.router.navigate(['/collections']);
  }

  openEditCollectionDialog(): void {
    const dialogConfig: MatDialogConfig<EditCollectionComponent> = {
      minWidth: '650px',
    };
    const dialogRef = this.dialog.open(EditCollectionComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => { });
  }

  onChange(event: MatTabChangeEvent) {
    this.tab1 = true;
    this.tab = event.tab.textLabel;
    this.selectedTabIndex = event.index;
  }


  ngOnDestroy(): void {
    this.languagesData$?.unsubscribe();
    this.timeZoneData$?.unsubscribe();
    this.collectionPostData$?.unsubscribe();
  }
}

